module.exports = __webpack_public_path__ + "img/Z8.1982bcd5.jpg";